import { render, staticRenderFns } from "./customerStatements.vue?vue&type=template&id=2a234a7a"
import script from "./customerStatements.ts?vue&type=script&lang=js&external"
export * from "./customerStatements.ts?vue&type=script&lang=js&external"
import style0 from "../customer.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports